
function fitVids() {

    let $viewports  = jQuery('.js-fit-video');
        $viewports.each(function() {

        let $video     = jQuery(this).find('video');
        let $container = jQuery(this).parent();

        let min_w = 300;
        let vid_w_orig = parseInt($video.attr('width'));
        let vid_h_orig = parseInt($video.attr('height'));

        jQuery(this).width($container.width());

        let scale_h = $container.width() / vid_w_orig;
        let scale_v = $container.height() / vid_h_orig;
        let scale = scale_h > scale_v ? scale_h : scale_v;

        if (scale * vid_w_orig < min_w) {scale = min_w / vid_w_orig;};

        jQuery(this).width($container.width() * 5);
        jQuery(this).css({marginLeft: -($container.width() * 2)});

        $video.width(scale * vid_w_orig);
        $video.height('auto');

        jQuery(this).scrollLeft(($video.width() - $container.width()) / 2);
        jQuery(this).scrollTop(($video.height() - $container.height()) / 2);
    })
};

jQuery(window).resize(function () { fitVids(); });

module.exports = fitVids;